/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import RowLayout from '@components/RowLayout';
import useResponsive from '@hooks/useResponsive';
import { Stack, Typography } from '@mui/material';
import i18n from '@utils/i18n';
import React, { useState, useEffect, useRef } from 'react';

const isEnglish = () => {
  const lang = localStorage.getItem('i18nextLng')?.toLowerCase() === 'en';
  return lang;
};
const Result = () => {
  const [activeRowIndex, setActiveRowIndex] = useState(0);
  const rowRefs = useRef([]);
  const t = i18n.getFixedT(null, null, 'pages.flagshop.result');
  const showResult = useResponsive('up', 1300);
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      rowRefs.current.forEach((row, index) => {
        if (row) {
          const rect = row.getBoundingClientRect();
          // Check if the row is in the center of the viewport
          if (
            rect.top <= window.innerHeight / 2 &&
            rect.bottom >= window.innerHeight / 2
          ) {
            setActiveRowIndex(index);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Initialize rowRefs with 3 elements
  if (rowRefs.current.length === 0) {
    rowRefs.current = Array(3).fill(null);
  }

  // Add ref to array
  const addToRefs = (el, index) => {
    if (el && !rowRefs.current.includes(el)) {
      rowRefs.current[index] = el;
    }
  };

  return (
    <RowLayout
      sx={{
        width: '100%',
        height: {
          md: '2150px',
          xs: '1220px',
          sm: isEnglish() ? '1790px' : '1680px'
        },
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',

        zIndex: 0
      }}
    >
      <Stack
        sx={{
          display: showResult ? 'flex' : 'none',
          width: { md: '75%', lg: '100%' },
          maxWidth: '1920px',
          px: { md: 0, lg: '320px' }
        }}
      >
        {/* Row 1 */}
        <Stack
          ref={(el) => addToRefs(el, 0)}
          sx={{
            width: '100%',
            maxWidth: '1920px',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backgroundColor: '#FFFFFF',
            minHeight: '518px',
            height: activeRowIndex === 0 ? '750px' : '518px',
            py: activeRowIndex === 0 ? '200px' : '158px',

            transition: 'all 0.5s ease-in-out'
          }}
        >
          <Stack
            sx={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: '100%'
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: activeRowIndex === 0 ? '400px' : '200px',
                color: '#244EE2',
                fontFamily: 'Swear Display',
                fontStyle: 'italic',
                textAlign: 'left',
                lineHeight: '100%',
                whiteSpace: 'nowrap',

                letterSpacing: activeRowIndex === 0 ? '-20px' : '-10px',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              55 +
            </Typography>
            <Typography
              sx={{
                ml: '0px',
                mb: '45px',
                fontSize: '24px',
                color: '#244EE2',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: '-1.2px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('1.unit')}
            </Typography>
          </Stack>
          <Stack sx={{ gap: '30px', mt: '30px' }}>
            <Typography
              sx={{
                fontSize:
                  activeRowIndex === 0
                    ? isEnglish()
                      ? '40px'
                      : '48px'
                    : '32px',
                color: '#313131',
                fontWeight: 700,
                lineHeight: '100%',
                letterSpacing: activeRowIndex === 0 ? '-2.4px' : '-1.6px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('1.title')}
            </Typography>
            <Typography
              sx={{
                fontSize:
                  activeRowIndex === 0
                    ? isEnglish()
                      ? '20px'
                      : '24px'
                    : '18px',
                color: '#000',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: activeRowIndex === 0 ? '-1.2px' : '-0.9px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('1.subtitle')}
            </Typography>
          </Stack>
        </Stack>

        {/* Row 2 */}
        <Stack
          ref={(el) => addToRefs(el, 1)}
          sx={{
            width: '100%',
            maxWidth: '1920px',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            position: 'sticky',
            top: 0,
            zIndex: 11,
            backgroundColor: '#FFFFFF',
            minHeight: '518px',
            height:
              activeRowIndex === 1 || activeRowIndex === 0 ? '750px' : '518px',
            py:
              activeRowIndex === 1 || activeRowIndex === 0 ? '200px' : '158px',
            borderTop: '1px solid #D9D9D9',

            transition: 'all 0.5s ease-in-out'
          }}
        >
          <Stack
            sx={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: '100%'
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize:
                  activeRowIndex === 1 || activeRowIndex === 0
                    ? '300px'
                    : '200px',
                color: '#244EE2',
                fontFamily: 'Swear Display',
                fontStyle: 'italic',
                textAlign: 'left',
                lineHeight: '100%',
                whiteSpace: 'nowrap',
                letterSpacing:
                  activeRowIndex === 1 || activeRowIndex === 0
                    ? '-20px'
                    : '-10px',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              180 +
            </Typography>
            <Typography
              sx={{
                ml: '0px',
                mb: '45px',
                fontSize: '24px',
                color: '#244EE2',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: '-1.2px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('2.unit')}
            </Typography>
          </Stack>
          <Stack sx={{ gap: '30px', mt: '30px' }}>
            <Typography
              sx={{
                fontSize:
                  activeRowIndex === 1 || activeRowIndex === 0
                    ? isEnglish()
                      ? '40px'
                      : '48px'
                    : '32px',
                color: '#313131',
                fontWeight: 700,
                lineHeight: '100%',
                letterSpacing:
                  activeRowIndex === 1 || activeRowIndex === 0
                    ? '-2.4px'
                    : '-1.6px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('2.title')}
            </Typography>
            <Typography
              sx={{
                fontSize:
                  activeRowIndex === 1 || activeRowIndex === 0
                    ? isEnglish()
                      ? '20px'
                      : '24px'
                    : '18px',
                color: '#000',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing:
                  activeRowIndex === 1 || activeRowIndex === 0
                    ? '-1.2px'
                    : '-0.9px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('2.subtitle')}
            </Typography>
          </Stack>
        </Stack>

        {/* Row 3 */}
        <Stack
          ref={(el) => addToRefs(el, 2)}
          sx={{
            width: '100%',
            maxWidth: '1920px',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'row',
            position: 'sticky',
            top: 0,
            zIndex: 12,
            backgroundColor: '#FFFFFF',
            minHeight: '518px',
            height: '750px',
            py: '200px',
            borderTop: '1px solid #D9D9D9',
            borderBottom: 'none',
            transition: 'all 0.5s ease-in-out'
          }}
        >
          <Stack
            sx={{
              flexDirection: 'row',
              alignItems: 'flex-end',
              width: '100%'
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '250px',
                color: '#244EE2',
                fontFamily: 'Swear Display',
                fontStyle: 'italic',
                textAlign: 'left',
                lineHeight: '100%',
                whiteSpace: 'nowrap',

                letterSpacing: '-20px',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              3000 +
            </Typography>
            <Typography
              sx={{
                ml: '0px',
                mb: '45px',
                fontSize: '24px',
                color: '#244EE2',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: '-1.2px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('3.unit')}
            </Typography>
          </Stack>
          <Stack sx={{ gap: '30px', mt: '30px' }}>
            <Typography
              sx={{
                fontSize: isEnglish() ? '40px' : '48px',
                color: '#313131',
                fontWeight: 700,
                lineHeight: '100%',
                letterSpacing: '-2.4px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('3.title')}
            </Typography>
            <Typography
              sx={{
                fontSize: isEnglish() ? '20px' : '24px',
                color: '#000',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: '-1.2px',
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('3.subtitle')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Stack
        sx={{
          width: { xs: '100%', md: '75%' },
          height: '100%',
          display: !showResult ? 'flex' : 'none',
          px: { xs: '20px', sm: '40px', md: 0 },
          py: { xs: '60px', sm: '100px' },
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        {/* Row 1 */}
        <Stack
          sx={{
            width: '100%',

            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',

            backgroundColor: '#FFFFFF',
            pb: { xs: '60px', sm: '140px' },
            borderBottom: '1px solid #D9D9D9'
          }}
        >
          <Stack
            sx={{
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'center', sm: 'flex-end' },
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: { xs: '120px', sm: '200px' },
                color: '#244EE2',
                fontFamily: 'Swear Display',
                fontStyle: 'italic',
                textAlign: 'left',
                lineHeight: '100%',
                whiteSpace: 'nowrap',

                letterSpacing: { xs: '-6px', sm: '-10px' },
                transition: 'all 0.5s ease-in-out'
              }}
            >
              55 +
            </Typography>
            <Typography
              sx={{
                ml: { xs: 1, sm: 1 },
                mb: { sm: 2 },
                fontSize: { xs: '20px', sm: 24 },
                color: '#244EE2',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: { xs: '-1px', sm: '-1.2px' },
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('1.unit')}
            </Typography>
          </Stack>
          <Stack
            sx={{
              gap: '30px',
              mt: '30px',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 24, sm: 32 },
                color: '#313131',
                fontWeight: 700,
                lineHeight: '100%',
                letterSpacing: { xs: '-1.2px', sm: '-1.6px' },
                whiteSpace: 'nowrap'
              }}
            >
              {t('1.title')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '18px', sm: '24px' },
                color: '#000',
                fontWeight: 500,
                lineHeight: '130%',
                textAlign: 'center',
                letterSpacing: { xs: '-0.9px', sm: '-1.2px' },
                whiteSpace: {
                  xs: 'pre-line',
                  sm: isEnglish() ? 'pre-line' : 'nowrap'
                },
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('1.subtitle-mobile')}
            </Typography>
          </Stack>
        </Stack>

        {/* Row 2 */}
        <Stack
          sx={{
            width: '100%',
            mt: { xs: '60px', sm: '140px' },
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',

            backgroundColor: '#FFFFFF',
            pb: { xs: '60px', sm: '140px' },
            borderBottom: '1px solid #D9D9D9'
          }}
        >
          <Stack
            sx={{
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'center', sm: 'flex-end' },
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: { xs: '120px', sm: '200px' },
                color: '#244EE2',
                fontFamily: 'Swear Display',
                fontStyle: 'italic',
                textAlign: 'left',
                lineHeight: '100%',
                whiteSpace: 'nowrap',
                mr: 1,

                letterSpacing: { xs: '-6px', sm: '-10px' },
                transition: 'all 0.5s ease-in-out'
              }}
            >
              180 +
            </Typography>
            <Typography
              sx={{
                ml: { xs: 1, sm: 1 },
                mb: { sm: 2 },
                fontSize: { xs: '20px', sm: 24 },
                color: '#244EE2',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: { xs: '-1px', sm: '-1.2px' },
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('2.unit')}
            </Typography>
          </Stack>
          <Stack
            sx={{
              gap: '30px',
              mt: '30px',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 24, sm: 32 },
                color: '#313131',
                fontWeight: 700,
                lineHeight: '100%',
                letterSpacing: { xs: '-1.2px', sm: '-1.6px' },
                whiteSpace: 'nowrap'
              }}
            >
              {t('2.title')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '18px', sm: '24px' },
                color: '#000',
                fontWeight: 500,
                lineHeight: '130%',
                textAlign: 'center',
                letterSpacing: { xs: '-0.9px', sm: '-1.2px' },
                whiteSpace: {
                  xs: 'pre-line',
                  sm: isEnglish() ? 'pre-line' : 'nowrap'
                },
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('2.subtitle-mobile')}
            </Typography>
          </Stack>
        </Stack>

        {/* Row 3 */}
        <Stack
          sx={{
            width: '100%',
            mt: { xs: '60px', sm: '140px' },
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: 'column',

            backgroundColor: '#FFFFFF',
            pb: { xs: '60px', sm: '140px' }
          }}
        >
          <Stack
            sx={{
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'center', sm: 'flex-end' },
              justifyContent: 'center',
              width: '100%'
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: '120px',
                color: '#244EE2',
                fontFamily: 'Swear Display',
                fontStyle: 'italic',
                textAlign: 'left',
                lineHeight: '100%',
                whiteSpace: 'nowrap',

                mr: 1.5,
                letterSpacing: '-6px',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              3000 +
            </Typography>
            <Typography
              sx={{
                ml: 1,
                display: isEnglish() ? 'none' : 'flex',

                mb: { sm: 2 },
                fontSize: { xs: '20px', sm: 24 },
                color: '#244EE2',
                fontWeight: 500,
                lineHeight: '100%',
                letterSpacing: { xs: '-1px', sm: '-1.2px' },
                whiteSpace: 'nowrap',
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('3.unit')}
            </Typography>
          </Stack>
          <Stack
            sx={{
              gap: '30px',
              mt: '30px',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: 24, sm: 32 },
                color: '#313131',
                fontWeight: 700,
                lineHeight: '100%',
                letterSpacing: { xs: '-1.2px', sm: '-1.6px' },
                whiteSpace: 'nowrap'
              }}
            >
              {t('3.title')}
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '18px', sm: '24px' },
                color: '#000',
                fontWeight: 500,
                lineHeight: '130%',
                textAlign: 'center',
                letterSpacing: { xs: '-0.9px', sm: '-1.2px' },
                whiteSpace: {
                  xs: 'pre-line',
                  sm: isEnglish() ? 'pre-line' : 'nowrap'
                },
                transition: 'all 0.5s ease-in-out'
              }}
            >
              {t('3.subtitle-mobile')}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </RowLayout>
  );
};

export default Result;
